import login from './login';

export default {
  language: 'zh-CN',
  country: 'cn',
  name: '中文',
  embeddedLocale: login,
};
